// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-project-js": () => import("/opt/build/repo/src/pages/project.js" /* webpackChunkName: "component---src-pages-project-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-page-2-js": () => import("/opt/build/repo/src/pages/page-2.js" /* webpackChunkName: "component---src-pages-page-2-js" */)
}

